export const checkIsFreeProduct = (cartItem) => {
  if (cartItem?.totalPrice?.value == null || cartItem.updateable == null){
    return false;
  }

  return cartItem.totalPrice.value <= 0 && !(cartItem.updateable ?? true) && (cartItem.giveAway ?? false)
}

export const generateProductUrl = (code, shortName) => {
  const product_Name = shortName?.replace(/\W+/g, "-")?.toLowerCase();
  return `/p/${product_Name}-${code}`;
};